import React from 'react'
// components
import ApiSettings from 'components/PageComponents/Settings/Api/ApiTokens'
import TableManagementProvider from 'containers/Search/layers/BL'
// constants
import { API_TAB } from 'constants/apiSettings'

const ApiTokensContainer: React.FC = () => {
  const [tab, setTab] = React.useState(API_TAB)

  return (
    <TableManagementProvider>
      <ApiSettings tab={tab} setTab={setTab} />
    </TableManagementProvider>
  )
}

export default ApiTokensContainer
